var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 63,
    viewBox: "0 0 75 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4046 0.583984C19.1144 1.51786 0.0105 3.63974 0 29.6679V62.416H29.6565V27.3779H19.8091C19.1853 18.0221 26.8894 15.6063 35.2671 13.7519L32.4046 0.583984ZM72.1374 0.583984C58.8472 1.51786 39.7432 3.6398 39.7328 29.6679V62.416H69.3894V27.3779H59.542C58.9181 18.0221 66.6222 15.6063 75 13.7519L72.1374 0.583984Z",
    fill: "#EE7828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.fd09de7690ab8f275437c2951406b203.svg";
export { ForwardRef as ReactComponent };